var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',{staticClass:"text-center pt-4"},[_vm._v(" NotFound ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }